export const EDITOR_FONT_SIZES = [
  "8px",
  "9px",
  "10px",
  "11px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "36px",
  "48px",
  "72px",
];

export const EDITOR_HEADINGS = ["false", "1", "2", "3", "4", "5", "6"];

export const EDITOR_TABLE_SETTINGS = {
  language: "en_US",
  menus: ["column", "row", "merge", "table", "cell", "wrap", "copy", "delete"],
  toolbarTable: true,
};

export const EDITOR_HISTORY_SETTINGS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false,
};

// Heading level → visual style. Single source of truth used by:
//   • DocumentEditor.tsx  — heading dropdown preview (fontSize/fontWeight)
//   • quillHelper.ts      — PDF export normalization and pdfmake style map
//   • DocumentEditor.css  — .ql-editor h1-h6 rules (must be kept in sync manually)
export type HeadingStyleEntry = {
  fontSize: number;
  fontWeight: number;
  lineHeight: number;
};

export const EDITOR_HEADING_STYLES: Record<string, HeadingStyleEntry> = {
  false: { fontSize: 13, fontWeight: 400, lineHeight: 1.5 },
  "1": { fontSize: 23, fontWeight: 700, lineHeight: 1.2 },
  "2": { fontSize: 19, fontWeight: 700, lineHeight: 1.3 },
  "3": { fontSize: 17, fontWeight: 700, lineHeight: 1.4 },
  "4": { fontSize: 15, fontWeight: 700, lineHeight: 1.4 },
  "5": { fontSize: 13, fontWeight: 700, lineHeight: 1.4 },
  "6": { fontSize: 11, fontWeight: 700, lineHeight: 1.4 },
};

// PDF generation constants (declared before tableLayouts so hr line color is shared)
export const FILE_EXPORT_PARAMS = {
  DEFAULT_FONT_SIZE: 12,
  IMAGE_WIDTH: "320px",
  BLOCKQUOTE_STYLES: {
    borderLeft: "4px solid #e5e7eb",
    paddingLeft: "1em",
    color: "#6b7280",
    fontStyle: "italic",
    margin: "0.5em 0",
  },
  PAGE_MARGINS: [40, 70, 40, 60] as [number, number, number, number],
  FOOTER_MARGINS: [40, 10, 40, 10] as [number, number, number, number],
  PARAGRAPH_MARGINS: [0, 0, 0, 0] as [number, number, number, number],
  /** Vertical margin around &lt;hr&gt; rules in PDF (pt); keep small ? empty &lt;p&gt; between rules is stripped separately. */
  HR_LINE_MARGINS: [0, 1, 0, 1] as [number, number, number, number],
  /** Rule stroke color for &lt;hr&gt; in PDF table layout (Tailwind gray-300). */
  HR_LINE_COLOR: "#d1d5db",
  /**
   * Overrides html-to-pdfmake default `p` margin [0,5,0,10] so paragraph spacing is not huge in exports.
   * Order: [left, top, right, bottom] in pt.
   */
  PDFMAKE_DEFAULT_P_MARGIN: [0, 1, 0, 2] as [number, number, number, number],
} as const;

/** Marks hr-to-rule output so table normalization does not force body font-size on the rule. */
export const QUILL_HR_EXPORT_LINE_CLASS = 'quill-hr-export-line';

/** Letter header row tables ? see App.css (.table-borderless / .table-borderless-block). */
export const TABLE_BORDERLESS_CLASS = 'table-borderless';
export const TABLE_BORDERLESS_BLOCK_CLASS = 'table-borderless-block';
export const TABLE_TEXT_RIGHT_CLASS = 'text-right';
export const TABLE_TEXT_CENTER_CLASS = 'text-center';